import { render, staticRenderFns } from "./roam-bin-movement.vue?vue&type=template&id=b5aaf78a"
import script from "./roam-bin-movement.vue?vue&type=script&lang=js"
export * from "./roam-bin-movement.vue?vue&type=script&lang=js"
import style0 from "./roam-bin-movement.vue?vue&type=style&index=0&id=b5aaf78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports